import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectIntersectIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 6.25H17.75V2C17.75 1.5858 17.4142 1.25 17 1.25H2C1.5858 1.25 1.25 1.5858 1.25 2V17C1.25 17.4142 1.5858 17.75 2 17.75H6.25V22C6.25 22.4142 6.5858 22.75 7 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22V7C22.75 6.5858 22.4142 6.25 22 6.25ZM2.75 16.25V2.75H16.25V7.25H8C7.5858 7.25 7.25 7.5858 7.25 8V16.25H2.75ZM21.25 21.25H7.75V16.75H16C16.4142 16.75 16.75 16.4142 16.75 16V7.75H21.25V21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectIntersectIcon.displayName = 'SelectIntersectIcon';
